import { render, staticRenderFns } from "./DashboardBanner.vue?vue&type=template&id=56e21cf3&"
import script from "./DashboardBanner.vue?vue&type=script&lang=js&"
export * from "./DashboardBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports